const capitalizeFirstChar = (str: string) => (str ? `${str[0]?.toUpperCase()}${str.slice(1)}` : "");

export { capitalizeFirstChar };
